<script>
import { imgHost2 } from "@/config/index";


export default {
  props: {
    planData: {
      type: Array | Object,
      default: () => []
    }
  },
  data () {
    return {
      imgHost2
    };
  }
}
</script>

<template>
  <div v-if="planData" class="care-program">
    <div class="care-program-header"></div>
    <div class="care-program-header btlr">
      常见病兆
    </div>
    <div class="care-program-header">
      保健品方案
    </div>
    <div class="care-program-header btrr">
      安全注意事项
    </div>
    <div class="care-program-content care-program-step">
      <img :src="`${imgHost2}/qd_pic.png`" mode="aspectFit" class="care-program-step-pic" />
    </div>
    <div class="care-program-content">
      {{ planData.L.symptom }}
    </div>
    <div class="care-program-content">
      {{ planData.L.plan }}
    </div>
    <div class="care-program-content">
      {{ planData.L.precautions }}
    </div>
    <div class="care-program-content care-program-step">
      <img :src="`${imgHost2}/zd_pic.png`" mode="aspectFit" class="care-program-step-pic" />
    </div>
    <div class="care-program-content">
      {{ planData.M.symptom }}
    </div>
    <div class="care-program-content">
      {{ planData.M.plan }}
    </div>
    <div class="care-program-content">
      {{ planData.M.precautions }}
    </div>
    <div class="care-program-content care-program-step">
      <img :src="`${imgHost2}/zdu_pic.png`" mode="aspectFit" class="care-program-step-pic" />
    </div>
    <div class="care-program-content bblr">
      {{ planData.H.symptom }}
    </div>
    <div class="care-program-content">
      {{ planData.H.plan }}
    </div>
    <div class="care-program-content bbrr">
      {{ planData.H.precautions }}
    </div>
  </div>
  <div v-else>
    暂无数据
  </div>
</template>

<style lang="scss" scoped>
$borderRadius: 16px;

$activeBorderColor: #6580f8;

.care-program {
  position: relative;
  width: 100%;
  display: grid;
  grid-template-columns: auto 140px 180px 1fr;
  grid-template-rows: auto 1fr 1fr 1fr;

  >div {
    position: relative;
    width: 100%;
    height: 100%;
    text-align: center;
    font-size: 16px;
    font-weight: bold;

    &:not(:nth-child(4n + 1)) {
      padding: 20px 4px;
      background-color: #ebefff;
    }

    &:nth-child(4n + 3) {
      border-right: 4px solid $activeBorderColor;
      border-left: 4px solid $activeBorderColor;
    }

    &:nth-child(4n + 2),
    &:nth-child(4n + 3),
    &:nth-child(4n) {
      border-bottom: 2px solid #bfcdff;
    }

    &:nth-child(n + 13) {
      border-bottom: none;
    }

    &:nth-child(3) {
      border-top: 4px solid $activeBorderColor;
      border-top-left-radius: $borderRadius;
      border-top-right-radius: $borderRadius;
      overflow: hidden;
    }

    &:nth-last-child(2) {
      border-bottom: 8px solid $activeBorderColor;
      border-bottom-left-radius: $borderRadius;
      border-bottom-right-radius: $borderRadius;
      overflow: hidden;
    }
  }

  &-step {
    padding-right: 20px;

    &-pic {
      position: relative;
      height: 100%;
      min-width: 60px;
    }
  }
}

.btlr {
  border-top-left-radius: $borderRadius;
}

.btrr {
  border-top-right-radius: $borderRadius;
}

.bblr {
  border-bottom-left-radius: $borderRadius;
}

.bbrr {
  border-bottom-right-radius: $borderRadius;
}
</style>
